const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_\-+={[}\]|\\:;"'<,>.?/]).{5,}$/;

export function validateRegisterInput(username, email, password) {
  if (!username && !email && !password) {
    return "Please enter username, email and password.";
  }
  if (!username) {
    return "Please enter your full name.";
  }
  if (!email) {
    return "Please enter your email address.";
  }
  if (!emailRegex.test(email)) {
    return "Please enter a valid email address.";
  }
  if (!password) {
    return "Please enter your password.";
  }
  if (!passwordRegex.test(password)) {
    return "Password must be at least 5 characters long and include at least one uppercase letter, one number, and one special symbol.";
  }
  return null;
}

export function parseRegisterError(error) {
  const status = error?.status ?? error?.response?.status;

  if (!status) {
    return "An unexpected error occurred. Please try again later.";
  }

  if (status === 400 && error?.response?.data?.detail) {
    return error.response.data.detail;
  }

  switch (status) {
    case 409:
      return "User with this email already exists.";
    case 500:
      return "Server error. Please try again later.";
    default:
      return "An error occurred. Please try again.";
  }
}
